import { FirebaseOptions, getApps, getApp, initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth, User } from 'firebase/auth'
import { getFirestore } from '@firebase/firestore'
import { getStorage } from '@firebase/storage'
const firebaseConfig = {
    apiKey: "AIzaSyBh9bfi09HIoOl6FBpZOf6DCgaSiXANfdA",
    authDomain: "mazi-9e6d9.firebaseapp.com",
    projectId: "mazi-9e6d9",
    storageBucket: "mazi-9e6d9.appspot.com",
    messagingSenderId: "745971553767",
    appId: "1:745971553767:web:c3a07bb6b0a53d816ad942",
    measurementId: "G-QW86MR5C1N"
  };
function createFirebaseApp(config: FirebaseOptions) {
  if (!getApps.length) {
    const firebaseApp = initializeApp(config)
    if (typeof window !== 'undefined') {
      if ('measurementId' in firebaseConfig) {
        getAnalytics()
      }
      return firebaseApp
    }
    return firebaseApp
  } else {
    return getApp()
  }
}
const firebaseApp = createFirebaseApp(firebaseConfig)
export const fireAuth = getAuth(firebaseApp)
export const fireStore = getFirestore(firebaseApp)
export const fireStorage = getStorage(firebaseApp)
export const auth = {
  currentUser: null as (User | null),
  token : ''
}